import { render, staticRenderFns } from "./DeptMng.vue?vue&type=template&id=0f49822e&scoped=true&"
import script from "./DeptMng.vue?vue&type=script&lang=js&"
export * from "./DeptMng.vue?vue&type=script&lang=js&"
import style0 from "./DeptMng.vue?vue&type=style&index=0&id=0f49822e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f49822e",
  null
  
)

export default component.exports